export default __webpack_public_path__ + "static/media/CI2.05f2938c.png";